import { Webhook } from 'lucide-react';
import BaseNode from '../BaseNode';
import { CATEGORY_COLORS } from '../../../constants';

export default function WebhookNode({ id, data, selected }) {
  const summary = data.method ? `${data.method} ${data.url || ''}`.trim() : null;

  return (
    <BaseNode
      id={id}
      selected={selected}
      color={CATEGORY_COLORS.triggers}
      icon={Webhook}
      label={data.label}
      hasInput={false}
    >
      <p className="text-xs text-gray-500">{summary || data.description}</p>
    </BaseNode>
  );
}
